import type { ReactNode } from 'react'

/**
 * The tinted pill used for statuses — "در انتظار تکمیل", "قفل", tier labels.
 *
 * The design builds all of them the same way: a radius-20 fill of the tone's
 * colour at 12% with the label and any icon in the tone at full strength.
 */
export type BadgeTone = 'primary' | 'success' | 'danger' | 'gold' | 'neutral' | 'pending'

const TONE: Record<BadgeTone, string> = {
  primary: 'bg-primary-glow/12 text-primary-glow',
  success: 'bg-success/12 text-success',
  danger: 'bg-danger/12 text-danger',
  gold: 'bg-gold/12 text-gold',
  neutral: 'bg-surface-8 text-ink-80',
  // The transaction feed's pill for anything still under way.
  pending: 'bg-[#eab308]/12 text-[#ffb200]',
}

interface BadgeProps {
  children: ReactNode
  tone?: BadgeTone
  icon?: ReactNode
}

export function Badge({ children, tone = 'primary', icon }: BadgeProps) {
  return (
    <span
      className={`flex h-[23px] shrink-0 items-center gap-1.5 rounded-20 px-2.5 ${TONE[tone]}`}
    >
      <span className="text-12 leading-[19px] font-semibold">{children}</span>
      {icon}
    </span>
  )
}
